import React from 'react';
import ErrorMessage from '../../../ErrorMessage';

export default class SelectWithFilter extends React.Component {
  static defaultProps = {
    showSelectFilterAt: 10,
    selectValues: [],
    filterCleared: false,
    className: 'w-100 form-control form-control-sm',
    onChange: () => {},
    fieldName: 'defaultFieldname',
    value: null,
    // Opt-in server-side search: when set, typing in the filter box calls this with the raw text instead of
    // filtering the given options client-side (and it no longer auto-selects the first match). The parent is
    // then responsible for replacing `selectValues`. The filter box is always shown in this mode.
    onFilterChange: null,
    filterPlaceholder: 'Type to search...',
  };

  constructor(props) {
    super(props);
    this.state = {
      // value:props.value,
      filter: '',
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    // M: This is used to clear the filter field too on clear all button press.
    // The filterCleared value from prop originates from InputWithClear's prop,
    // which comes from GeneralSearch's filterCleared state.
    if (this.props.filterCleared && this.state.filter !== '') {
      this.setState({ filter: '' });
    }
  }

  // The filter box shows either when server-side search is wired up or when there are enough options to be
  // worth filtering client-side. It costs the <select> half its width (the w-50/w-50 split below), so a field
  // whose list can never get long switches it off by passing a showFilterAt above any possible option count.
  shouldShowFilter() {
    return this.props.onFilterChange !== null || this.props.selectValues.length > this.props.showSelectFilterAt;
  }

  onFilterInputChange(filter) {
    // Server-side search: delegate to the parent, don't auto-select or filter the current options.
    if (this.props.onFilterChange !== null) {
      this.setState({ filter });
      this.props.onFilterChange(filter);
      return;
    }

    const first = this.props.selectValues.find((value) => value.label.toLowerCase().includes(filter.toLowerCase()));
    const value = first !== undefined ? first.value : '';
    this.setState({ filter, value });
    if (value) this.props.onChange({ value });
  }

  renderFilterField() {
    if (this.shouldShowFilter()) {
      return (
        <input
          type='text'
          className='w-50 form-control'
          placeholder={this.props.filterPlaceholder}
          value={this.state.filter}
          onChange={(e) => this.onFilterInputChange(e.target.value)}
          id={`htmlidfor${this.props.fieldName}`}
          key={`keyfilter${this.props.fieldName}`}
          autoComplete='off'
        />
      );
    }
    return null;
  }

  renderOption(label, value, disabled, index) {
    return (
      <option
        value={value}
        key={`key${index}`}
        disabled={disabled}
      >
        {label}
      </option>
    );
  }

  render() {
    // In server-side mode the parent already returns the matching options (and may append the currently
    // selected one, whose label won't necessarily match the typed text), so don't also filter client-side.
    const clientFilter = this.props.onFilterChange !== null ? '' : this.state.filter;
    let options = [];
    try {
      options = this.props.selectValues
        .filter((v) => v.label.toLowerCase().includes(clientFilter.toLowerCase()))
        .map((v, index) => this.renderOption(v.label, v.value, v.disabled, index));
    } catch (err) {
      ErrorMessage.LogDevInfo(err, 'LogDevinfo.js - render', ErrorMessage.NotProd);
    }
    const cn = this.shouldShowFilter() ? 'w-50' : 'w-100';

    return (
      <div className={'d-flex w-100'}>
        {this.renderFilterField()}
        <select
          className={cn}
          children={options}
          onChange={(e) => {
            this.setState({
              value: e.value,
            });
            this.props.onChange(e.target);
          }}
          // value={ this.state.value===null ? "" : this.state.value }
          value={this.props.value === null ? '' : this.props.value}
          key={`keyselect${this.props.fieldName}`}
        />
      </div>
    );
  }
}
